import Icon from "./IconBase.js";
import PropTypes from "prop-types";
const MeetLinkIconDisable = (props) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.14355 8.65693V13.9284C7.14355 14.5719 7.30141 15.1776 7.5757 15.7141H11.1464C11.6521 15.7141 12.1436 15.2048 12.1436 14.7469V7.87193L11.9428 7.85693H7.94355C7.50141 7.85693 7.14355 8.21479 7.14355 8.65693Z"
          fill="black"
        />
        <path
          d="M11.3083 5.71436H9.18262C9.4869 6.67007 10.3712 7.3665 11.4276 7.3665C11.6783 7.3665 11.9148 7.31721 12.1419 7.24507V6.54793C12.1419 6.08936 11.7669 5.71436 11.3083 5.71436Z"
          fill="black"
        />
        <path
          d="M17.7662 7.85693H14.1998L13.2041 8.66193V12.6541C13.2041 14.1362 14.4055 15.3376 15.8877 15.3376C17.3698 15.3376 18.5712 14.1362 18.5712 12.6541V8.66193C18.5712 8.21765 18.2105 7.85693 17.7662 7.85693Z"
          fill="#757575"
        />
        <path
          d="M17.8576 5.35749C17.8576 6.34392 17.0583 7.14321 16.0718 7.14321C15.0854 7.14321 14.2861 6.34392 14.2861 5.35749C14.2861 4.37106 15.0854 3.57178 16.0718 3.57178C17.0583 3.57178 17.8576 4.37106 17.8576 5.35749Z"
          fill="#757575"
        />
        <path
          d="M7.94355 7.85693H14.2007C14.6428 7.85693 15.0007 8.21479 15.0007 8.65693V13.9284C15.0007 16.0984 13.2421 17.8569 11.0721 17.8569C8.90213 17.8569 7.14355 16.0984 7.14355 13.9284V8.65693C7.14355 8.21479 7.50141 7.85693 7.94355 7.85693Z"
          fill="#757575"
        />
        <path
          d="M13.7951 4.99973C13.7951 6.30687 12.7358 7.36616 11.4287 7.36616C10.1215 7.36616 9.06152 6.30687 9.06152 4.99973C9.06152 3.69259 10.1215 2.6333 11.4287 2.6333C12.7358 2.6333 13.7951 3.69259 13.7951 4.99973Z"
          fill="#757575"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.18473 5.71436H11.3104C11.769 5.71436 12.144 6.08936 12.144 6.54793V7.24507C11.9169 7.31721 11.6804 7.3665 11.4297 7.3665C10.3733 7.3665 9.48902 6.67007 9.18473 5.71436ZM7.14453 13.9285V8.6571C7.14453 8.21495 7.50239 7.8571 7.94453 7.8571H11.9438L12.1445 7.8721V14.7471C12.1445 15.205 11.6531 15.7142 11.1474 15.7142H7.57667C7.30239 15.1778 7.14453 14.5721 7.14453 13.9285Z"
          fill="black"
        />
        <path
          d="M10.5942 15H2.26059C1.80273 15 1.42773 14.625 1.42773 14.1664V5.83357C1.42773 5.375 1.80273 5 2.26059 5H10.5942C11.0527 5 11.4277 5.375 11.4277 5.83357V14.1664C11.4277 14.625 11.0527 15 10.5942 15Z"
          fill="#333333"
        />
        <path
          d="M8.70178 8.26972H6.99535V12.8569H5.87392V8.26972H4.1582V7.14258H8.70178V8.26972Z"
          fill="white"
        />
      </svg>
    </Icon>
  );
};
MeetLinkIconDisable.propTypes = {
  id: PropTypes.string,
};
export default MeetLinkIconDisable;
